const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Aasthik Upadhyay</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Joint Secretary, UPES-CSI</li>
    <li>
        Passionate about technology and community building.
    </li>
    <li>
        Leading initiatives for student engagement and technical excellence.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
